<template>
  <div class="minePage">
    <div class="mineHeader">
      <div class="mineHeader__left" @click="$parent.goNav($store.state.token ? '/userInfo' : '/login')">
        <div class="mineAvatar">
          <img :src="$store.state.userInfo.avatar ? $store.state.userInfo.avatar : '/static/image/imageAvatar02@3x.png'" alt="" />
          <input v-if="$store.state.token" class="mineAvatar__input" type="file" @change="onchangemd" single accept="image/gif,image/png" />
        </div>
        <div class="mineIdentity">
          <div class="mineIdentity__title" v-if="$store.state.token">
            <span class="mineIdentity__name">{{ $store.state.userInfo.username }}</span>
            <span class="mineIdentity__vip" v-if="$store.state.userInfo && String($store.state.userInfo.vip || '') !== ''">VIP{{ $store.state.userInfo.vip }}</span>
          </div>
          <div class="mineIdentity__title" v-else>点击登录/注册</div>
          <div class="mineIdentity__sub" v-if="$store.state.token">加入{{ ($store.state.appInfo && $store.state.appInfo.title) || '' }}乐享{{ $store.state.userInfo.joinday || 0 }}天</div>
          <div class="mineIdentity__sub" v-else>立即体验VIP特权</div>
        </div>
      </div>
      <div class="mineHeader__right">
        <div class="mineHeader__icon" @click="$parent.goNav('/userCent')">
          <img src="/iomg2/set.png" alt="" />
        </div>
        <div class="mineHeader__icon" @click="$parent.goNav('/message')">
          <img src="/iomg2/mes.png" alt="" />
        </div>
      </div>
    </div>

    <div class="vipCard" v-if="!$store.state.token" @click="$parent.goNav('/vip')">
      <div class="vipCard__top">
        <img class="vipCard__badge" src="/static/image/vipnew.png" alt="" />
        <div class="vipCard__title">加入VIP专享豪礼</div>
      </div>
      <div class="vipCard__perks">
        <div class="vipCard__perk">每周红包</div>
        <div class="vipCard__perk">晋级礼金</div>
        <div class="vipCard__perk">专属豪礼</div>
        <div class="vipCard__perk">生日礼金</div>
      </div>
    </div>

    <div class="vipPanel" v-else @click="$parent.goNav('/vip')">
      <div class="vipPanel__header">
        <div class="vipPanel__balance" @click.stop="toggleBalance">
          <div class="vipPanel__balanceValue">￥{{ showBalance ? formatMoney($store.state.userInfo.balance) : '****' }}</div>
          <img class="vipPanel__eye" :src="showBalance ? '/static/style/eyeProtection.9c3b54cce3890f35ffa75be8d73dccf7.png' : '/static/style/eyeClose.b521c925e76020a02e183b378e36f4b6.png'" alt="" />
        </div>
        <div class="vipPanel__actions">
          <div class="vipPanel__action" @click.stop="$parent.goNav('/recharge')">存款</div>
          <div class="vipPanel__action" @click.stop="$parent.goNav('/transfer')">转账</div>
          <div class="vipPanel__action" @click.stop="$parent.goNav('/withdrawal')">取款</div>
        </div>
      </div>

      <div class="vipPanel__flowRow">
        <div class="vipPanel__flowText">流水(元) {{ formatMoney(currentFlow) }}/{{ formatMoney(nextFlow) }}</div>
        <div class="vipPanel__more" @click.stop="$parent.goNav('/vip')">更多VIP特权 ></div>
      </div>

      <div class="vipPanel__progress">
        <div class="vipPanel__progressRow">
          <span class="vipPanel__vipLabel">VIP{{ currentVip }}</span>
          <div class="vipPanel__progressTrack">
            <div class="vipPanel__progressFill" :style="{ width: flowPercent + '%' }"></div>
          </div>
          <span class="vipPanel__vipLabel">VIP{{ nextVip }}</span>
        </div>
      </div>

      <div class="vipPanel__perks">
        <div class="vipPanel__perk">
          <span class="vipPanel__perkIcon"><img src="/iomg2/meizh.png" alt="" /></span>
          <span>每周红包</span>
        </div>
        <div class="vipPanel__perk">
          <span class="vipPanel__perkIcon"><img src="/iomg2/jins.png" alt="" /></span>
          <span>晋级礼金</span>
        </div>
        <div class="vipPanel__perk">
          <span class="vipPanel__perkIcon"><img src="/iomg2/gifi.png" alt="" /></span>
          <span>专属豪礼</span>
        </div>
        <div class="vipPanel__perk">
          <span class="vipPanel__perkIcon"><img src="/iomg2/brithday.png" alt="" /></span>
          <span>生日礼金</span>
        </div>
      </div>
    </div>

    <div class="bonusCard">
      <div class="bonusCard__top">
        <div class="bonusCard__left">
          <div class="bonusCard__text">
            <div class="bonusCard__title">福利中心</div>
            <div class="bonusCard__sub">BONUS CENTER</div>
          </div>
        </div>
        <div class="bonusCard__btn" @click="$parent.goNav('/welfare')">领取福利</div>
      </div>

      <div class="bonusGrid">
        <div class="bonusItem" @click="$parent.goNav('/transRecord')">
          <div class="bonusItem__icon"><img src="/home/jiaoyi.png" alt="" /></div>
          <div class="bonusItem__label">交易记录</div>
        </div>
        <div class="bonusItem" @click="$parent.goNav('/betRecord')">
          <div class="bonusItem__icon"><img src="/home/touzhu.png" alt="" /></div>
          <div class="bonusItem__label">投注记录</div>
        </div>
        <div class="bonusItem" @click="$parent.goNav('/fanshui')">
          <div class="bonusItem__icon"><img src="/home/shishi.png" alt="" /></div>
          <div class="bonusItem__label">实时返水</div>
        </div>
        <div class="bonusItem" @click="$parent.goNav('/userCent')">
          <div class="bonusItem__icon"><img src="/home/acc.png" alt="" /></div>
          <div class="bonusItem__label">账户管理</div>
        </div>
        <div class="bonusItem" @click="$parent.goNav('/zhanzhu')">
          <div class="bonusItem__icon"><img src="/home/tuiguang.png" alt="" /></div>
          <div class="bonusItem__label">分享赚钱</div>
        </div>
        <div class="bonusItem" @click="$parent.openKefu()">
          <div class="bonusItem__icon"><img src="/home/xinxi.png" alt="" /></div>
          <div class="bonusItem__label">意见反馈</div>
        </div>
        <div class="bonusItem" @click="$parent.goNav('/boutBallBet')">
          <div class="bonusItem__icon"><img src="/home/help.png" alt="" /></div>
          <div class="bonusItem__label">帮助中心</div>
        </div>
        <div class="bonusItem" @click="$parent.goNav('/applyagent')">
          <div class="bonusItem__icon"><img src="/home/us.png" alt="" /></div>
          <div class="bonusItem__label">加入我们</div>
        </div>
      </div>
    </div>

    <div class="mineList">
      <div class="mineList__item" @click="$parent.goNav('/activityRecord')">
        <div class="mineList__left">
          <img class="mineList__icon" src="/static/image/help.png" alt="" />
          <span>活动记录</span>
        </div>
        <img class="mineList__arrow" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
      </div>
      <div class="mineList__item" @click="$parent.goNav('/app')">
        <div class="mineList__left">
          <img class="mineList__icon" src="/static/image/appxiazaus.png" alt="" />
          <span>APP下载</span>
        </div>
        <img class="mineList__arrow" src="/static/style/icoArrowGrey@2x.abc43ab099390c4587d33290a76fc15e.png" alt="" />
      </div>
    </div>

    <div class="mineBottomSpace"></div>
  </div>
</template>
<script>
export default {
  name: 'mine',
  data() {
    return {
      activitylistList: [],
      showBalance: true,
      bfNum: 0,
      vipLis: [],
    };
  },
  computed: {
    currentVip() {
      const v = Number(this.$store.state.userInfo && this.$store.state.userInfo.vip);
      return Number.isFinite(v) ? v : 0;
    },
    nextVip() {
      const cur = this.currentVip;
      const max = this.vipLis && this.vipLis.length ? this.vipLis.length : cur + 1;
      return Math.min(cur + 1, max);
    },
    currentFlow() {
      const v = Number(this.$store.state.userInfo && this.$store.state.userInfo.totalgame);
      return Number.isFinite(v) ? v : 0;
    },
    nextFlow() {
      const idx = this.nextVip - 1;
      const flow = this.vipLis && this.vipLis[idx] ? this.vipLis[idx].flow : 0;
      const v = Number(flow);
      return Number.isFinite(v) ? v : 0;
    },
    flowPercent() {
      const total = this.nextFlow;
      if (!total) return 0;
      const p = (this.currentFlow / total) * 100;
      if (!Number.isFinite(p)) return 0;
      if (p >= 100) return 100;
      if (p <= 0) return 0;
      return Math.round(p);
    },
  },
  created() {
    let that = this;
    if (that.$store.state.token) {
      that.activitylist();
      that.uservip();
    }
  },
  methods: {
    toggleBalance() {
      this.showBalance = !this.showBalance;
    },
    formatMoney(val) {
      const n = Number(val);
      if (!Number.isFinite(n)) return '0.00';
      return n.toFixed(2);
    },
    onchangemd(e) {
      let that = this;

      console.log(e.target.files); //这个就是选中文件信息
      let formdata = new FormData();
      Array.from(e.target.files).map(item => {
        console.log(item);
        formdata.append('file', item); //将每一个文件图片都加进formdata
      });
      //  axios.post("接口地址", formdata).then(res => { console.log(res) })
      that.$parent.showLoading();

      that.$apiFun.post('/api/uploadimg', formdata).then(res => {
        that.$parent.hideLoading();

        that.$parent.getUserInfoShowLoding();
      });
    },
    uservip() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/uservip', {})
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.vipLis = res.data;
            that.getbfNum();
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbfNum() {
      let that = this;
      let num = 0; //当前vip充值钱
      let vip = that.$store.state.userInfo.vip * 1; //当前vip等级
      that.vipLis.forEach((el, index) => {
        console.log();
        if (index == vip) {
          num = el.recharge * 1;
        }
      });
      let userMey = that.$store.state.userInfo.paysum * 1;
      let bfNum = userMey == 0 || num == 0 ? 0 : Math.round((userMey / num) * 100);
      that.bfNum = bfNum > 100 ? 100 : bfNum;
      console.log(111);
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.$parent.showTost(0, res.message);
          that.$parent.getUserInfoShowLoding();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.minePage {
  min-height: 100vh;
  background: #ede9e7;
  box-sizing: border-box;
  padding: 14px 14px 0;
  color: #2f2a26;
}

.mineHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mineHeader__left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}

.mineAvatar {
  position: relative;
  width: 54px;
  height: 54px;
  border-radius: 27px;
  overflow: hidden;
  background: #fff;
  flex: 0 0 auto;
}

.mineAvatar img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.mineAvatar__input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.mineIdentity {
  min-width: 0;
  margin-left: 12px;
}

.mineIdentity__title {
  font-size: 16px;
  font-weight: 800;
  color: #4e6693;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mineIdentity__name {
  vertical-align: middle;
}

.mineIdentity__vip {
  margin-left: 0.08rem;
  display: inline-flex;
  align-items: center;
  height: 0.2rem;
  padding: 0 0.06rem;
  border-radius: 0.06rem;
  font-size: 0.12rem;
  font-weight: 700;
  color: #8a6a3a;
  background: #d8b07a;
  vertical-align: middle;
}

.mineIdentity__sub {
  margin-top: 6px;
  font-size: 12px;
  color: #a2aec8;
}

.mineHeader__right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}

.mineHeader__icon {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}

.mineHeader__icon img {
  width: 18px;
  height: 18px;
  display: block;
}

.vipCard {
  margin-top: 12px;
  border-radius: 16px;
  background: #2f2f2f;
  padding: 14px 14px 12px;
  color: #fff;
}

.vipCard__top {
  display: flex;
  align-items: center;
}

.vipCard__badge {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.12);
  padding: 6px;
  box-sizing: border-box;
}

.vipCard__title {
  margin-left: 10px;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.5px;
}

.vipCard__perks {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.vipCard__perk {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.82);
  background: rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 6px 10px;
}

.vipPanel {
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 0.28rem;
  background: #2d2d2d;
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 0.12rem 0.3rem rgba(0, 0, 0, 0.22);
  padding: 0.28rem 0.26rem 0.26rem;
  color: #fff;
}

.vipPanel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.18rem;
}

.vipPanel__balance {
  display: flex;
  align-items: center;
  gap: 0.12rem;
  min-width: 0;
}

.vipPanel__balanceValue {
  font-size: 0.46rem;
  font-weight: 900;
  letter-spacing: 0.3px;
  white-space: nowrap;
  color: #e7d0b3;
}

.vipPanel__eye {
  width: 0.3rem;
  height: 0.3rem;
  display: block;
  opacity: 0.9;
}

.vipPanel__actions {
  display: flex;
  align-items: center;
  gap: 0.14rem;
  flex: 0 0 auto;
}

.vipPanel__action {
  height: 0.54rem;
  padding: 0 0.28rem;
  border-radius: 0.16rem;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.06);
  color: #e7d0b3;
  font-size: 0.2rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vipPanel__flowRow {
  margin-top: 0.22rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.14rem;
}

.vipPanel__flowText {
  font-size: 0.2rem;
  color: rgba(255, 255, 255, 0.65);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vipPanel__more {
  font-size: 0.2rem;
  color: #e7d0b3;
  flex: 0 0 auto;
}

.vipPanel__progress {
  margin-top: 0.22rem;
}

.vipPanel__progressRow {
  display: flex;
  align-items: center;
  gap: 0.16rem;
}

.vipPanel__vipLabel {
  font-size: 0.22rem;
  color: rgba(255, 255, 255, 0.78);
  flex: 0 0 auto;
}

.vipPanel__progressTrack {
  height: 0.12rem;
  border-radius: 0.12rem;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
  flex: 1;
  min-width: 0;
}

.vipPanel__progressFill {
  height: 100%;
  background: linear-gradient(90deg, #b8895e, #efd1a8);
  border-radius: 0.12rem;
}

.vipPanel__perks {
  margin-top: 0.26rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.16rem;
}

.vipPanel__perk {
  flex: 1;
  min-width: 0;
  height: 0.68rem;
  border-radius: 0.34rem;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: inset 0 0.01rem 0 rgba(255, 255, 255, 0.06);
  padding: 0 0.16rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.12rem;
  font-size: 0.2rem;
  color: rgba(255, 255, 255, 0.88);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vipPanel__perkIcon {
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  flex: 0 0 auto;
  background: rgba(231, 208, 179, 0.18);
  border: 1px solid rgba(231, 208, 179, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.vipPanel__perkIcon img {
  width: 0.26rem;
  height: 0.26rem;
  display: block;
  object-fit: contain;
}

.bonusCard {
  margin-top: 12px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}

.bonusCard__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: url('/home/flbg.png') no-repeat 50%;
  background-size: 100% auto;
  padding: 0.08rem 0.16rem;
}

.bonusCard__left {
  display: flex;
  align-items: center;
  min-width: 0;
  margin-left: 0.06rem;
}

.bonusCard__img {
  width: 36px;
  height: 36px;
  border-radius: 0;
  background: transparent;
  padding: 0;
}

.bonusCard__text {
  margin-left: 1.5rem;
  min-width: 0;
}

.bonusCard__title {
  font-size: 14px;
  font-weight: 800;
  color: #2f2a26;
}

.bonusCard__sub {
  margin-top: 2px;
  font-size: 10px;
  color: #b59c86;
  letter-spacing: 0.6px;
}

.bonusCard__btn {
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  border: 1px solid rgba(192, 143, 96, 0.6);
  color: #c08f60;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  flex: 0 0 auto;
}

.bonusGrid {
  margin-top: 10px;
  padding: 0 0.12rem 0.12rem;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px 6px;
}

.bonusItem {
  min-width: 0;
  text-align: center;
}

.bonusItem__icon {
  width: 0.48rem;
  height: 0.48rem;
  margin: 0 auto;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bonusItem__icon img {
  width: 0.48rem;
  height: 0.48rem;
  display: block;
}

.bonusItem__label {
  margin-top: 6px;
  font-size: 12px;
  color: #4e6693;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mineList {
  margin-top: 12px;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}

.mineList__item {
  height: 44px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.mineList__item:last-child {
  border-bottom: none;
}

.mineList__left {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #4e6693;
  font-size: 14px;
  font-weight: 600;
}

.mineList__icon {
  width: 18px;
  height: 18px;
  display: block;
}

.mineList__arrow {
  width: 6px;
  display: block;
  opacity: 0.7;
}

.mineBottomSpace {
  height: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/mine.vue